export default __webpack_public_path__ + "static/media/workouts_icon.697f4d16.svg";